import { BehaviorSubject } from 'rxjs';
import { getCapabilitySpecifications } from 'src/app/shared/capabilities-and-permissions';
import { CapabilityIdEnum } from 'src/app/shared/capabilities-and-permissions/capability-id.enum';

RoleEditionController.$inject = ['$scope', 'AngularSpinnerService', '$state', '$stateParams', '$translate', 'loggedUser', 'UsersRolesFactory', 'TopToolbarFactory', 'AlertingFactory',
  'company', 'AngularSitesService', 'DropdownItemsFactory'];
export function RoleEditionController($scope, AngularSpinnerService, $state, $stateParams, $translate, loggedUser, UsersRolesFactory, TopToolbarFactory, AlertingFactory,
  company, AngularSitesService, DropdownItemsFactory) {

  $scope.company = company;
  $scope.goBack = goBack;
  $scope.updateSaveBtn = updateSaveBtn;

  $scope.groupPermissionColumnChange = groupPermissionColumnChange;
  $scope.groupPermissionLineChange = groupPermissionLineChange;
  $scope.siteGroupPermissionChange = siteGroupPermissionChange;
  $scope.groupPermissionsColumnMap = new Map();
  $scope.sitesGroupPermissionsMap = new Map();
  $scope.permissionsGroupsBS = new BehaviorSubject(null);

  $scope.permissionColumnChange = permissionColumnChange;
  $scope.permissionLineChange = permissionLineChange;
  $scope.sitePermissionChange = sitePermissionChange;
  $scope.permissionsColumnMap = new Map();
  $scope.sitesPermissionsMap = new Map();
  $scope.permissionsBS = new BehaviorSubject(null);

  $scope.refreshUsersBS = new BehaviorSubject(false);
  $scope.sitesGroupsReference = [];
  $scope.sitesReference = [];

  init();

  // Go back to users or roles table depending on where we got here from
  function goBack() {
    UsersRolesFactory.redirectToUsersTeamsRoles($state, $stateParams.trackTable === 'users' ? 0 : 2);
  }

  function permissionColumnChange(permission) {
    const { id: permissionId } = permission;
    const currentLength = $scope.permissionsColumnMap.get(permissionId).size;


    if (!currentLength || $scope.permissionsColumnMap.get(permissionId).size < $scope.sitesIdsReference.length) {
      // If partial or no selection, add all.
      $scope.sitesIdsReference.forEach(siteId => {
        $scope.sitesPermissionsMap.get(siteId).add(permissionId);
        $scope.permissionsColumnMap.get(permissionId).add(siteId);
      });
    } else {
      $scope.permissionsColumnMap.get(permissionId).clear();
      $scope.sitesReference.forEach(site => $scope.sitesPermissionsMap.get(site.id).delete(permissionId));
    }
    _refreshPermissionsPerAccount();

  }

  function permissionLineChange(siteId) {
    const currentLength = $scope.sitesPermissionsMap.get(siteId).size;


    if (!currentLength || $scope.sitesPermissionsMap.get(siteId).size < $scope.allPermissions.length) {
      // If partial or no selection, add all.
      $scope.allPermissions.forEach(({ id }) => {
        $scope.sitesPermissionsMap.get(siteId).add(id);
        $scope.permissionsColumnMap.get(id).add(siteId);
      });
    } else {
      $scope.sitesPermissionsMap.get(siteId).clear();
      $scope.allPermissions.forEach(({ id }) =>
        $scope.permissionsColumnMap.get(id).delete(siteId)
      );
    }
    _refreshPermissionsPerAccount();

  }

  function sitePermissionChange({ siteId, permissionId }) {
    if ($scope.sitesPermissionsMap.get(siteId).has(permissionId)) {
      $scope.sitesPermissionsMap.get(siteId).delete(permissionId);
      $scope.permissionsColumnMap.get(permissionId).delete(siteId);
    } else {
      $scope.sitesPermissionsMap.get(siteId).add(permissionId);
      $scope.permissionsColumnMap.get(permissionId).add(siteId);
    }
    _refreshPermissionsPerAccount();
  }

  function groupPermissionColumnChange(permission) {
    const { id: permissionId } = permission;
    const currentLength = $scope.groupPermissionsColumnMap.get(permissionId).size;

    if (!currentLength || $scope.groupPermissionsColumnMap.get(permissionId).size < $scope.sitesGroupsIdsReference.length) {
      // If partial or no selection, add all.
      $scope.sitesGroupsIdsReference.forEach(siteId => {
        $scope.sitesGroupPermissionsMap.get(siteId).add(permissionId);
        $scope.groupPermissionsColumnMap.get(permissionId).add(siteId);
      });
    } else {
      $scope.groupPermissionsColumnMap.get(permissionId).clear();
      $scope.sitesGroupsReference.forEach(site => $scope.sitesGroupPermissionsMap.get(site.id).delete(permissionId));
    }
    _refreshPermissionsPerAccountsGroup();

  }

  function groupPermissionLineChange(siteId) {
    const currentLength = $scope.sitesGroupPermissionsMap.get(siteId).size;


    if (!currentLength || $scope.sitesGroupPermissionsMap.get(siteId).size < $scope.allPermissions.length) {
      // If partial or no selection, add all.
      $scope.allPermissions.forEach(({ id }) => {
        $scope.sitesGroupPermissionsMap.get(siteId).add(id);
        $scope.groupPermissionsColumnMap.get(id).add(siteId);
      });
    } else {
      $scope.sitesGroupPermissionsMap.get(siteId).clear();
      $scope.allPermissions.forEach(({ id }) =>
        $scope.groupPermissionsColumnMap.get(id).delete(siteId)
      );
    }
    _refreshPermissionsPerAccountsGroup();

  }

  function siteGroupPermissionChange({ siteId, permissionId }) {
    if ($scope.sitesGroupPermissionsMap.get(siteId).has(permissionId)) {
      $scope.sitesGroupPermissionsMap.get(siteId).delete(permissionId);
      $scope.groupPermissionsColumnMap.get(permissionId).delete(siteId);
    } else {
      $scope.sitesGroupPermissionsMap.get(siteId).add(permissionId);
      $scope.groupPermissionsColumnMap.get(permissionId).add(siteId);
    }
    _refreshPermissionsPerAccountsGroup();
  }

  function _refreshPermissionsPerAccountsGroup() {
    $scope.permissionsGroupsBS.next({
      columnMap: $scope.groupPermissionsColumnMap,
      lineMap: $scope.sitesGroupPermissionsMap,
    });
    updateSaveBtn();
  }

  function _refreshPermissionsPerAccount() {
    $scope.permissionsBS.next({
      columnMap: $scope.permissionsColumnMap,
      lineMap: $scope.sitesPermissionsMap,
    });
    updateSaveBtn();
  }

  function enableSave() {
    TopToolbarFactory.updateButtonDisable(false, $scope);
    $scope.saveBtnState = 1;
  }

  function disableSave() {
    TopToolbarFactory.updateButtonDisable(true, $scope);
    $scope.saveBtnState = 0;
  }

  function updateSaveBtn() {
    // Role name mandatory - disable save btn if not filled 
    if ($scope.role.name && !$scope.role.is_static) {
      enableSave();
    } else {
      disableSave();
    }
  }

  function save() {
    const clearEmptySet = dict => {
      (Object.keys(dict) || []).forEach(key => {
        if (!dict[key].size) {
          delete dict[key];
        }
      })
    }

    const cleanPermissions = (permissionsMap) => {
      const capabilities = Object.fromEntries(permissionsMap);
      const allowedCapabilities = Object.values(CapabilityIdEnum);
      Object.keys(capabilities).forEach(siteId => {
        const capabilitiesCleaned = [...capabilities[siteId]].filter(permissionId => allowedCapabilities.includes(permissionId));
        capabilities[siteId] = new Set(capabilitiesCleaned);
      });
      return capabilities;
    }

    $scope.role.capabilities_by_site_id = cleanPermissions($scope.sitesPermissionsMap);
    $scope.role.capabilities_by_site_group_id = cleanPermissions($scope.sitesGroupPermissionsMap);

    clearEmptySet($scope.role.capabilities_by_site_id);
    clearEmptySet($scope.role.capabilities_by_site_group_id);

    UsersRolesFactory.updateRole(company.id, $scope.role).then(() => {
      AlertingFactory.success('users_roles/update_role_success');
      disableSave();
    }, AlertingFactory.httpErrorHandler());
  }

  function init() {
    // If there is no role passed to role edition redirect back to main page
    if (!$stateParams.role || !$stateParams.role.name) {
      UsersRolesFactory.redirectToUsersTeamsRoles($state, 0);
    }
    TopToolbarFactory.setFirstLevelNavTranslation('users_roles/roles', $scope, () => UsersRolesFactory.redirectToUsersTeamsRoles($state, 2));
    if (!$stateParams.role.is_static) {
      TopToolbarFactory.setButton('save', save, $scope);
    }
    $scope.backToLabel = $stateParams.trackTable === 'users' ? $translate.instant('users_roles/back_to_users_table') : $translate.instant('users_roles/back_to_roles_table');

    // Tooltips
    $scope.roleTooltips = {
      admin: $translate.instant('users_roles/role_edition/tooltips/admin'),
      pushMode: $translate.instant('users_roles/role_edition/tooltips/pushMode'),
    };

    $scope.allPermissions = getCapabilitySpecifications();
    $scope.allPermissions.forEach(permission => {
      $scope.groupPermissionsColumnMap.set(permission.id, new Set())
      $scope.permissionsColumnMap.set(permission.id, new Set())
    });

    $scope.sitesGroupsReference = DropdownItemsFactory.buildSiteGroupItems(AngularSitesService.siteGroupsV2)
      .filter(({ id }) => Object.keys(AngularSitesService.siteGroupsV2Map.get(id).sites)?.length);
    $scope.sitesGroupsIdsReference = $scope.sitesGroupsReference.map(({ id }) => id);

    $scope.sitesGroupsIdsReference.forEach(siteGroupId => $scope.sitesGroupPermissionsMap.set(siteGroupId, new Set()));
    $scope.sitesReference = DropdownItemsFactory.buildSiteItems(AngularSitesService.sitesV2.filter(({ site_group_id }) => !site_group_id));
    $scope.sitesIdsReference = $scope.sitesReference.map(({ id }) => id);
    $scope.sitesIdsReference.forEach(siteId => $scope.sitesPermissionsMap.set(siteId, new Set()));


    $scope.role = $stateParams.role;
    TopToolbarFactory.setTitle($scope.role.name, $scope);
    if ($scope.role.capabilities_by_site_group_id) {
      (Object.keys($scope.role.capabilities_by_site_group_id) || []).forEach((siteGroupId) => {
        $scope.sitesGroupPermissionsMap.set(+siteGroupId, new Set($scope.role.capabilities_by_site_group_id[+siteGroupId]));
        $scope.role.capabilities_by_site_group_id[+siteGroupId].forEach(id => $scope.groupPermissionsColumnMap.get(+id)?.add(+siteGroupId));
      });
    }
    if ($scope.role.capabilities_by_site_id) {
      (Object.keys($scope.role.capabilities_by_site_id) || []).forEach((siteId) => {
        $scope.sitesPermissionsMap.set(+siteId, new Set($scope.role.capabilities_by_site_id[+siteId]));
        $scope.role.capabilities_by_site_id[+siteId].forEach(id => $scope.permissionsColumnMap.get(+id)?.add(+siteId));
      });
    }

    $scope.$watch('role.name', () => {
      TopToolbarFactory.setTitle($scope.role.name, $scope);
      $scope.usersCardTitle = `${$translate.instant('users_roles/users_card_title')} "${$scope.role.name}"`;
    });
    _refreshPermissionsPerAccountsGroup();
    _refreshPermissionsPerAccount();

    disableSave();
  }



  $scope.$watch('selectedIndex', () => {
    if (!$stateParams.role || !$stateParams.role.is_static) {
      if ($scope.selectedIndex === 0) {
        TopToolbarFactory.setButton('save', save, $scope);
        $scope.saveBtnState === 1 ? enableSave() : disableSave();
      } else {
        TopToolbarFactory.setButton('users_roles/update_users', saveUsersSelectionForRole, $scope);
      }
    } else {
      TopToolbarFactory.clearButton($scope);

    }
  });


  // **************************************************************
  // **************************************************************
  // **************************************************************
  // USERS 
  // **************************************************************
  // **************************************************************
  // **************************************************************

  $scope.usersSelectionChanged = usersSelectionChanged;

  function usersSelectionChanged(selectedUserSet) {
    $scope.selectedUserSet = selectedUserSet;

  }

  function saveUsersSelectionForRole() {
    AngularSpinnerService.showSpinner();
    UsersRolesFactory.updateUserForRole(company.id, $scope.role.id, Array.from($scope.selectedUserSet) || [])
      .catch(AlertingFactory.httpErrorHandler())
      .finally(() => {
        AngularSpinnerService.hideSpinner();
        $scope.refreshUsersBS.next(true);
      });
  }
}
